
const acctSettings = {
  type: 'accountSettingsNotifications',
  label: 'Account',
  settings: [
    { text: 'Confirm Associated Email', key: 'confirmSecondaryEmail', disabled: true },
    { text: 'Reset Password', key: 'resetPassword', disabled: true },
    { text: 'New User Request', key: 'newUserRequest', disabled: true },
  ],
};

const activity = {
  type: 'activityNotifications',
  label: 'Activity',
  settings: [
    { text: 'Shared Marketing Materials', key: 'sharedMM' },
  ],
};

const onlineNotifications = {
  label: 'Online/Offline',
  settings: [
    {
      text: 'Receive email notifications when my company is online',
      key: 'alwaysOffline',
      disabled: false,
      isBool: true,
      type: 'emailNotifications',
    },
    {
      text: 'Receive out of office reply notifications',
      key: 'outOfOfficeReplies',
      disabled: false,
      isBool: true,
      type: 'outOfOffice',
    },
  ],
};

const opts = (isPaidUser, companyType, hasContractingAccess) => {
  const system = {
    label: 'System Generated Email Notifications',
    settings: [
      {
        text: 'Monthly Digest',
        key: 'digest',
        isBool: true,
        type: 'weekly',
      }, {
        text: 'Weekly Partner Request Reminder',
        key: 'connectionReminder',
        isBool: true,
        type: 'weekly',
      },
      { text: 'New Company Sign Ups', key: 'newCompLocReady', disabled: !isPaidUser, type: 'connectionsNotifications' },
      { text: 'Accepted Partner Request', key: 'accepted', type: 'connectionsNotifications' },
      { text: 'New Partner Request', key: 'request', type: 'connectionsNotifications' },
    ],
  };

  const contractingSupplier = [
    { text: 'New Contract Request', key: 'request', disabled: !hasContractingAccess, type: 'contractingNotifications' },
    { text: 'Contract Status Changes', key: 'statusChange', disabled: !hasContractingAccess, type: 'contractingNotifications' },
    { text: 'New Messages', key: 'newMessage', disabled: !hasContractingAccess, type: 'contractingNotifications' },
  ];
  const contractingBuyer = [
    { text: 'New Contract', key: 'request', disabled: !hasContractingAccess, type: 'contractingNotifications' },
    { text: 'Contract Updates', key: 'updates', disabled: !hasContractingAccess, type: 'contractingNotifications' },
    { text: 'New Messages', key: 'newMessage', disabled: !hasContractingAccess, type: 'contractingNotifications' },
  ];


  const assetReceiving = {
    label: 'Email Message',
    assetReceiving: true,
    settings: [
      { text: 'General message', key: 'message', disabled: false, type: 'workspaceNotifications' },
      { text: 'Marketing Materials', key: 'sharedMM', disabled: false, type: 'activityNotifications' },
      {
        label: 'Contracting',
        assetReceiving: true,
        settings: companyType === 'Supplier' ? contractingSupplier : contractingBuyer,
      },
    ],
  };
  return [
    onlineNotifications,
    system,
    assetReceiving,
  ];
};

// pass in T || F for all fields
// export const options = (onTc, isPaidUser, hasContractingAccess) =>
// onTc ? R.prepend(acctSettings, opts(onTc, isPaidUser, hasContractingAccess)) : opts(onTc);
export const options = (onTc, isPaidUser, companyType, hasContractingAccess) => (
  onTc ? opts(isPaidUser, companyType, hasContractingAccess) : [
    workspace,
    {
      type: 'connections',
      label: 'Connections',
      settings: [{ text: 'New Connection Request', key: 'request' }],
    },
  ]);

// external notifications
export const defaultAllChecked = {
  activity: { sharedMM: ['email'] },
  connections: { request: ['email'] },
  workspace: { mesage: ['email'], bulkmessage: ['email'] },
  contracting: { newMessage: ['email'], updates: ['email'] },
};

export const unsubscribeAll = {
  activity: { sharedMM: [] },
  connections: { request: [] },
  workspace: { message: [], bulkmessage: [] },
  contracting: { newMessage: [], updates: [] },
};



// WEBPACK FOOTER //
// ./src/app/components/settings/notificationOptions.jsx